export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return "—";
  return d.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};

export const fmtMoney = (n) =>
  n == null || isNaN(n) ? "—" : `$${Number(n).toLocaleString("en-US")}`;

export const fmtRate = (r) => (r == null || isNaN(r) ? "—" : `${Number(r).toFixed(2)}%`);
